module.exports = __webpack_public_path__ + "static/media/Curoflow telemedicine platform in Switzerland.13c04dd9.webp";